import { loadGame } from './src/typescript/controllers/game_controllers/loadGameController'

console.log('Made by Živojin Nedeljković')

loadGame()
